import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SetupPageService } from '@core/services/setup-page/setup-page.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalService } from '@core/services/modal/modal.service';
import { ShareService } from '@core/services/share-data/share-data.service';
import { ServerDataService } from '@core/services/server-data/server-data.service';
import { SaveSessionBlindsService } from '@core/services/save-session-blinds/save-session-blinds.service';

@Component({
	selector: 'app-deposit-success-modal',
	templateUrl: './deposit-success-modal.component.html',
	styleUrls: ['./deposit-success-modal.component.scss', './deposit-success-modal.responsive.scss'],
})
export class DepositSuccessModalComponent implements OnInit, OnDestroy {
	static readonly ID = crypto.randomUUID();

	private destroy$ = new Subject<void>();
	protected downloading: boolean;

	constructor(
		private modalService: ModalService,
		private countryCodeService: SetupPageService,
		private shareService: ShareService,
		private serverDataService: ServerDataService,
		private saveSessionBlindService: SaveSessionBlindsService,
		private dialogRef: MatDialogRef<DepositSuccessModalComponent>,
	) {}

	ngOnInit() {
		this.modalService.liftUpModal(this.dialogRef);

		this.dialogRef
			.beforeClosed()
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => {
				this.countryCodeService.resetOnBeforeUnloadHandler();
				window.location.reload();
			});
		this.shareService.setDialogState({ id: DepositSuccessModalComponent.ID, isOpen: true });
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		this.shareService.setDialogState({ id: DepositSuccessModalComponent.ID, isOpen: false });
	}

	onClose(): void {
		this.countryCodeService.parseLocalLinkHandler();
	}

	onDownloadPdf(): void {
		this.downloading = true;

		const sessionKey = this.saveSessionBlindService.getSessionKeyForSavingHandler();
		this.serverDataService
			.getPdfData(this.serverDataService.serverData().rest.order_pdf(sessionKey))
			.then(() => (this.downloading = false));
	}
}
